/// <reference path="ReconciliationEntryState.ts" />

// The head of a bank account's movements in the reconciliation list: its ledger account, the
// bank's name and the IBAN.
class BankAccountReconciliationHeader extends MUIView
{
    private ledgerAccountLabel:MUILabel = null;
    private bankNameLabel:MUILabel = null;
    private ibanLabel:MUILabel = null;

    awakeFromHTML(){
        this.ledgerAccountLabel = MUIOutlet(this, "ledger-account-lbl", "MUILabel");
        this.bankNameLabel = MUIOutlet(this, "bank-name-lbl", "MUILabel");
        this.ibanLabel = MUIOutlet(this, "iban-lbl", "MUILabel");
    }

    set item(bankAccount:BankAccount) {
        let escape = ReconciliationEntryStateHelper.escape;
        let account = bankAccount as any;
        this.ledgerAccountLabel.text = escape(account?.ledgerAccount?.prefix);
        this.bankNameLabel.text = escape(account?.bank?.name);
        this.ibanLabel.text = escape(BankAccountReconciliationHeader.formatIBAN(account?.info?.iban));
    }

    /// "ES2121000418450200051332" -> "ES21 2100 0418 4502 0005 1332"
    static formatIBAN(iban:string) : string {
        if (iban == null) return "";
        let compact = iban.replace(/\s+/g, "");
        return compact.replace(/(.{4})(?=.)/g, "$1 ");
    }
}
